import { motion } from 'framer-motion';
import { Shield, Users, Zap, Heart } from 'lucide-react';
import { Section, SectionHeader } from '@/components/ui/Section';

const features = [
  {
    icon: Shield,
    title: 'Gameplay Premium',
    description:
      'Server yang stabil, optimized, dan bebas lag untuk pengalaman bermain terbaik.',
  },
  {
    icon: Users,
    title: 'Komunitas Aktif',
    description:
      'Staff yang aktif, development transparan, dan update berbasis komunitas.',
  },
  {
    icon: Zap,
    title: 'Fitur Lengkap',
    description:
      'Custom features, economy system, dan berbagai event seru menanti kamu.',
  },
  {
    icon: Heart,
    title: 'Indonesian First',
    description:
      'Server Hytale pertama di Indonesia, dibangun oleh dan untuk pemain Indonesia.',
  },
];

export function AboutSection() {
  return (
    <Section id="about">
      <SectionHeader
        subtitle="Tentang Kami"
        title="About Hytale Indonesia"
        description="Hytale Indonesia adalah server komunitas Hytale pertama di Indonesia, dibangun untuk memberikan pengalaman bermain premium bagi semua pemain."
      />

      {/* About Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="space-y-6 text-muted-foreground">
            <p>
              Kami fokus pada gameplay yang immersive, nilai komunitas yang kuat, dan
              development jangka panjang. Server kami dirancang untuk menjadi stabil,
              optimal, dan menyenangkan bagi pemain casual maupun competitive.
            </p>
            <p>
              Dengan staff yang aktif, development yang transparan, dan update
              berbasis komunitas, Hytale Indonesia bertujuan menjadi hub utama untuk
              pemain Hytale di seluruh Indonesia.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="grid grid-cols-2 gap-4"
        >
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="p-6 rounded-xl border border-border bg-card/50 hover:border-primary/30 transition-colors group"
            >
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                <feature.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="font-display font-semibold text-foreground mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-muted-foreground">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </Section>
  );
}
